import Styles from './YoutubeShort.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const YoutubeShort = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.youtubeShort} data-testid="youtube-short-frame-skin">
      {children}
      <Skin.CaptionBelow lines={3} maxCharacterCount={maxCharacterCount} />
    </Skin.Root>
  )
}

export default YoutubeShort
